module.exports = __webpack_public_path__ + "static/media/redText.a9f2a7f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/redText.png
// module id = 759
// module chunks = 0 1